import { ActionAfterViewed } from '@cian/action-after-viewed-component';
import * as React from 'react';

import { MortgageBrokerSidebarBanner } from './components/MortgageBrokerSidebarBanner';
import { trackMortgageBrokerSidebarBannerShow, trackMortgageBrokerSidebarBannerClick } from './tracking';
import { useApplicationContext } from '../ApplicationContext';

/**
 * Баннер сервиса "Ипотечный брокер" (Циан.Ипотека для профи) в сайдбаре.
 * Условие показа баннера задается снаружи, см. селектор [selectIsMortgageBrokerBannerAvailable](../../selectors/mortgageBroker/selectIsMortgageBrokerBannerAvailable.ts).
 */
export function MortgageBrokerSidebarBannerContainer() {
  const { config } = useApplicationContext();

  const mortgageBrokerPromoUrl =
    config.get<string>('mortgage-broker-application-frontend.promoUrl') + '?cian_source=object_card';

  return (
    <ActionAfterViewed callback={trackMortgageBrokerSidebarBannerShow}>
      <MortgageBrokerSidebarBanner
        linkUrl={mortgageBrokerPromoUrl}
        onLinkClick={trackMortgageBrokerSidebarBannerClick}
      />
    </ActionAfterViewed>
  );
}
